// 自动设置语言
var navLang = navigator.language;
var localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false;
var lang = window.localStorage.lang || localLang || 'zh-US';
export default {
    getLang: function () {
        var re = lang;
        return re;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/locale/index.ts
// module id = null
// module chunks = 